<div id="content-mobile">
  <header>
    <div class="container">
      <br />
      <div class="row">
        <div class="col-md-10">
        </div>
        <div class="col-md-2">
          <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700; ">
            <a [routerLink]="['/home']" style="text-decoration: none; color: inherit; ">
              <div class="container" style="border: 1px solid #257dff; border-radius: 25px; ">
                &nbsp;&nbsp;English
              </div>
            </a>
          </span>
        </div>
      </div>
    </div>
    <div class="container">
      <br />
      <div class="row">
        <div class="col-md-12">
          <span style="padding-top: 3%; font-size: 1.2em; font-weight: 700; width: 100%; float: left">
            GoogleAssistantPrivacyLitigation.com
            (877) 411-4704
          </span>
        </div>
      </div>
    </div>
    <br />
    <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #257dff ">
      <div class="container">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
          <ul class="navbar-nav flex-grow">
            <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
              <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color: white; font-weight: bold ">Inicio</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/faq']" style="color: white; font-weight: bold">Preguntas Frecuentes</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/notice']" style="color: white; font-weight: bold ">Aviso</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/login']" style="color:white; font-weight: bold ">Presentar su Reclamo</a>
            </li>

            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/claim-form']" style="color:white; font-weight: bold ">Formulario de Reclamo</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/court-documents']" style="color:white; font-weight: bold ">Documentos del Tribunal</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/exclusion-request']" style="color:white; font-weight: bold ">Solicitar Exclusión</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/contact']" style="color:white; font-weight: bold ">Contáctenos</a>
            </li>
          </ul>
        </div>
      </div>

    </nav>

    <div class="text-center" style="font-weight:bold">
      <div class="container" style="border:1px solid #bebaba">

        <br />

        Este sitio web oficial es mantenido por el Administrador de Reclamos.<br />
        <br />
      </div>
    </div>
  </header>
</div>

<div id="content-desktop">
  <header>
    <div class="container">
      <br />
      <div class="row">
        <div class="col-md-10">
        </div>
        <div class="col-md-2">
          <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700; ">
            <a [routerLink]="['/home']" style="text-decoration: none; color: inherit; ">
              <div class="container" style="border: 1px solid #257dff; border-radius: 25px; ">
                &nbsp;&nbsp;English
              </div>
            </a>
          </span>
        </div>
      </div>
    </div>
    <div class="container">
      <br />
      <div class="row">
        <div class="col-md-12">
          <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700">
            GoogleAssistantPrivacyLitigation.com
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(877) 411-4704
          </span>
        </div>
      </div>
    </div>
    <br />
    <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #257dff ">
      <div class="container">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
          <ul class="navbar-nav flex-grow">
            <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
              <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color: white; font-weight: bold ">Inicio</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/faq']" style="color: white; font-weight: bold">Preguntas Frecuentes</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/notice']" style="color: white; font-weight: bold ">Aviso</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/login']" style="color:white; font-weight: bold ">Presentar su Reclamo</a>
            </li>

            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/claim-form']" style="color:white; font-weight: bold ">Formulario de Reclamo</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/court-documents']" style="color:white; font-weight: bold ">Documentos del Tribunal</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/exclusion-request']" style="color:white; font-weight: bold ">Solicitar Exclusión</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/contact']" style="color:white; font-weight: bold ">Contáctenos</a>
            </li>
          </ul>
        </div>
      </div>

    </nav>

    <div class="text-center" style="font-weight:bold">
      <div class="container" style="border:1px solid #bebaba">

        <br />

        Este sitio web oficial es mantenido por el Administrador de Reclamos.<br />
        <br />
      </div>
    </div>
  </header>
</div>

<div class="row">
  <div class="col-md-12">

    <a [routerLink]="['/login']">
      <img src="../../../assets/Sp-main graphic.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 100%;">
    </a>

    <div class="panel-heading" style="background-color: #7dc7f4; color: black; text-align: center; font-weight: bold">
      <br />
      <h3>¿ESTOY INCLUIDO EN EL ACUERDO?</h3>
      <br />
    </div>
    <div class="container" style="border:1px solid #bebaba">

      <br />
      <br />
      <b>Usted es miembro del <i>Grupo de Compradores Demandantes</i> si es </b> un Usuario que compró un
      Dispositivo Fabricado por Google en los Estados Unidos o sus territorios entre el 18 de mayo de 2016
      y el 19 de marzo de 2026.<br /><br />

      <b>Usted es miembro del <i>Grupo de Demandantes por Privacidad</i> si es </b> un Usuario del Asistente
      de Google o fue miembro del Hogar de un Usuario entre el 18 de mayo de 2016 y el 19 de marzo de 2026,
      y sus comunicaciones fueron grabadas u obtenidas de otro modo por el Asistente de Google como resultado
      de una Aceptación Errónea o reveladas a cualquier proveedor de revisión externo.
      <br />
      <br />
    </div>

    <div class="panel-heading" style="background-color: #257dff; color: white; text-align: center; font-weight: bold">
      <br />
      <h3>
        PRESENTA UNA RECLAMACIÓN
      </h3>
      <br />
    </div>
  </div>
</div>
<div class="container" style="border:1px solid #bebaba">

  <br />


  <div class="row">
    <div class="col-md-6">

      <img src="../../../assets/Sp-icon.png" class="img-responsive" style="width:100%;  display: block; margin: 0 auto; width: 40%;">
    </div>
    <div class="col-md-6">
      <b>
        Para recibir un pago, debe completar y enviar oportunamente un Formulario de Reclamación válido antes del 27 de agosto de 2026
      </b>. Puede completar y enviar un Formulario de Reclamación electrónico en línea <a [routerLink]="['/login']">aquí</a>,
      o por correo postal a la dirección indicada en el Formulario de Reclamación, con matasellos del <b>27 de agosto de 2026</b> o antes.
      Puede obtener un Formulario de Reclamación imprimiéndolo <a href="../../../assets/documents/In re Google Assistant Claim Form_Final-ES.pdf"
                                                                  target="_blank">aquí</a> o llamando al 1-877-411-4704.<br /><br />

      <a [routerLink]="['/login']">

        <img src="../../../assets/Sp-button.png" class="img-responsive" style="width:100%; float: left; display: block; margin: 0 auto; width: 50%;">
      </a>
    </div>
  </div>
  <div class="row">
    <br />
  </div>
</div>

<div class="panel-heading" style="background-color: #7dc7f4; color: black; text-align: center; font-weight: bold">
  <br />
  <h3>
    RESUMEN DE SUS DERECHOS Y OPCIONES LEGALES
  </h3>
  <br />
</div>
<div class="container" style="border:1px solid #bebaba">

  <div class="row">
    <div class="col-md-12" style="text-align:center">
      <i>Sus derechos legales se ven afectados incluso si usted no actúa. Lea este aviso detenidamente.</i>
    </div>
  </div>
  <div id="content-mobile">
    <div class="row" style="margin-left: 5%; margin-right: 5%; margin-top: 5%; width: 100%; float: left; ">
      <div class="col-md-12">
        <div class="table-responsive" style="overflow-x: auto;">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th colspan="1" style="background-color:#ffffff; color:#000000; font-weight:bold; font-size:1.2em; text-align:center;">
                  Opción
                </th>
                <th colspan="1" style="background-color:#ffffff; color:#000000; font-weight:bold; font-size:1.2em; text-align:center;">
                  Explicación
                </th>
                <th colspan="1" style="background-color:#ffffff; color:#000000; font-weight:bold; font-size:1.2em; text-align:center;">
                  Fecha Límite
                </th>
              </tr>

            </thead>
            <tbody>
              <tr>
                <td style="background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20% ">
                  Permanecer en el/los Grupo(s) del Acuerdo, Presentar un Formulario de Reclamación y Recibir un Pago
                </td>
                <td style="background-color:white; color:#3e4144; width:60%">
                  Debe presentar un Formulario de Reclamación válido para recibir un pago. Esta es la única manera de recibir un pago. Usted renunciará a sus derechos de demandar a Google por su cuenta en relación con los reclamos del caso.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  La fecha límite del 27 de agosto de 2026 ya ha vencido.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Reincorporarse a los Grupos del Acuerdo (solo para personas que se excluyeron del litigio antes de la fecha límite del 9 de septiembre de 2024)
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  Si anteriormente se excluyó de este litigio antes de la fecha límite del 9 de septiembre de 2024, con base en el aviso del Grupo de Compradores certificado, usted permanece excluido de este Acuerdo a menos que tome medidas para reincorporarse, como presentar un Formulario de Reclamación.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  La fecha límite del 27 de agosto de 2026 ya ha vencido.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Excluirse
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  No recibir ningún pago.<br /><br />

                  Esta es la única opción que le permite conservar su derecho a ser parte de cualquier otra demanda contra Google
                  relacionada con los reclamos de este caso.<br /><br />

                  Si anteriormente se excluyó de este litigio antes de la fecha límite del 9 de septiembre de 2024, con base en el
                  aviso del Grupo de Compradores certificado, usted permanece excluido de este Acuerdo y no necesita excluirse nuevamente.<br /><br />

                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  La fecha límite del 27 de agosto de 2026 ya ha vencido.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Objetar el Acuerdo
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  Usted puede escribirle al Tribunal para expresar por qué está a favor o en contra del Acuerdo.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  La fecha límite del 27 de agosto de 2026 ya ha vencido.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Asistir a una Audiencia
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  Usted puede hablar ante el Tribunal sobre la imparcialidad del Acuerdo en la audiencia de aprobación final el 1 de octubre de 2026, siempre que proporcione aviso oportuno de su intención de comparecer.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  La fecha límite del 27 de agosto de 2026 ya ha vencido.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  No Hacer Nada
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  No recibir ningún pago. Renunciar a sus derechos de demandar a Google en relación con los reclamos de este caso.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div id="content-desktop">
    <div class="row" style="margin-left:5%;margin-right:5%; margin-top:5%">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th colspan="1" style="background-color:#ffffff; color:#000000; font-weight:bold; font-size:1.2em; text-align:center;">
                  Opción
                </th>
                <th colspan="1" style="background-color:#ffffff; color:#000000; font-weight:bold; font-size:1.2em; text-align:center;">
                  Explicación
                </th>
                <th colspan="1" style="background-color:#ffffff; color:#000000; font-weight:bold; font-size:1.2em; text-align:center;">
                  Fecha Límite
                </th>
              </tr>

            </thead>
            <tbody>
              <tr>
                <td style="background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20% ">
                  Permanecer en el/los Grupo(s) del Acuerdo, Presentar un Formulario de Reclamación y Recibir un Pago
                </td>
                <td style="background-color:white; color:#3e4144; width:60%">
                  Debe presentar un Formulario de Reclamación válido para recibir un pago. Esta es la única manera de recibir un pago. Usted renunciará a sus derechos de demandar a Google por su cuenta en relación con los reclamos del caso.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  La fecha límite del 27 de agosto de 2026 ya ha vencido.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Reincorporarse a los Grupos del Acuerdo (solo para personas que se excluyeron del litigio antes de la fecha límite del 9 de septiembre de 2024)
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  Si anteriormente se excluyó de este litigio antes de la fecha límite del 9 de septiembre de 2024, con base en el aviso del Grupo de Compradores certificado, usted permanece excluido de este Acuerdo a menos que tome medidas para reincorporarse, como presentar un Formulario de Reclamación.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  La fecha límite del 27 de agosto de 2026 ya ha vencido.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Excluirse
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  No recibir ningún pago.<br /><br />

                  Esta es la única opción que le permite conservar su derecho a ser parte de cualquier otra demanda contra Google
                  relacionada con los reclamos de este caso.<br /><br />

                  Si anteriormente se excluyó de este litigio antes de la fecha límite del 9 de septiembre de 2024, con base en el
                  aviso del Grupo de Compradores certificado, usted permanece excluido de este Acuerdo y no necesita excluirse nuevamente.<br /><br />

                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  La fecha límite del 27 de agosto de 2026 ya ha vencido.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Objetar el Acuerdo
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  Usted puede escribirle al Tribunal para expresar por qué está a favor o en contra del Acuerdo.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  La fecha límite del 27 de agosto de 2026 ya ha vencido.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Asistir a una Audiencia
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  Usted puede hablar ante el Tribunal sobre la imparcialidad del Acuerdo en la audiencia de aprobación final el 1 de octubre de 2026, siempre que proporcione aviso oportuno de su intención de comparecer.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  La fecha límite del 27 de agosto de 2026 ya ha vencido.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  No Hacer Nada
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  No recibir ningún pago. Renunciar a sus derechos de demandar a Google en relación con los reclamos de este caso.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <br />
  <br />

  <div class="row">
    <div class="col-md-12">
      <img src="../../../assets/people graphic.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 50%;">
    </div>
  </div>
</div>
<div class="panel-heading" style="background-color: #257dff; color: black; text-align: center; font-weight: bold">
  <br />
  <div>
    <a [routerLink]="['/login']">
      <img src="../../../assets/Sp-button.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 20%;">
    </a><br />
  </div>
  <p style="text-align:center; color:white">
    Si tiene preguntas o desea más información,<br />
    puede llamar o comunicarse con el Administrador de Reclamaciones por correo electrónico, o escribiendo a:<br />

    Google Assistant Privacy Settlement<br />
    c/o A.B. Data, Ltd.<br />
    PO Box 170500<br />
    Milwaukee, WI 53217<br />
    Línea gratuita: 1-877-411-4704<br />
    Correo electrónico: <a href="mailto:info@GoogleAssistantPrivacyLitigation.com" style="color:white">info@GoogleAssistantPrivacyLitigation.com</a><br /><br />

    <b>
      POR FAVOR NO LLAME NI ESCRIBA AL TRIBUNAL O A LA OFICINA DEL SECRETARIO DEL TRIBUNAL PARA OBTENER INFORMACIÓN.<br />
      EL TRIBUNAL NO PUEDE RESPONDER NINGUNA PREGUNTA.

    </b>
  </p>
  <br />
</div>
<br />
<br />

























